const capitalize = value => value.replace(/(^|\s)\S/g, l => l.toUpperCase());

export default capitalize;
